const extensionListener = callback => {
  window.addEventListener('message', callback);
};

const checkExtensionStat = () => {
  window.dispatchEvent(new Event('InstalledCheck'));
};

export { extensionListener, checkExtensionStat };
